import React from 'react';

import { CategoriesMobileDisplayOption } from 'src/gql/graphql';
import { ListProps } from '../categories-nav.types';
import { List } from './list';
import { Item } from './list.styles';
import { TextCard } from '../cards/text-card';

export const TextList = ({ categories, style, mobileDisplay, heading }: ListProps): JSX.Element => {
  const isMobileGrid = mobileDisplay === CategoriesMobileDisplayOption.grid;

  return (
    <List mobileDisplay={mobileDisplay} enableViewAll={false} heading={heading}>
      {categories.map((category) => (
        <Item key={category.key} $isMobileGrid={isMobileGrid}>
          <TextCard category={category} style={style} isMobileGrid={isMobileGrid} />
        </Item>
      ))}
    </List>
  );
};
